import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import DatePicker from "react-datepicker"
import Selectsearch from "react-select"
import {
	FormGroup,
	Label,
	
} from 'reactstrap';
import {   
    allStudents, 
    addTravelForm,
    allSSTeam
    
 } from 'Actions';

 import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
 
 class AddItems extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };
    UNSAFE_componentWillMount() {
		this.props.allStudents();  
        this.props.allSSTeam();
      
	}
    constructor(props) {
      
        super(props);
        this.state = {
              student: '',
            viewdiv:true,
              
              
           };
          
     }
    
     
   addHandleSubmit(event){
    event.preventDefault();
    this.props.addTravelForm(event).then((data) => {   
       
        if(data.status==1){                    
                document.getElementById("addform").reset();
                setTimeout(this.props.onClick, 5000);
        }
    });
    
}  

    

   
render() {

    const { studentlists,loading} = this.props;
    

    const allstudent=studentlists.map((stdval) => {  
          return {
            label: stdval.student,  
            value: stdval.uudID
        
          }
    });
        return(
            <div>
                     <RctCollapsibleCard heading="Travel Form Details" fullBlock>
                        <div className="col-md-6">
                          <FormGroup>
                                <Label for="Select">Name *</Label>
                                    <Selectsearch   className="form-control h-auto w-100" id="student" name="student" options={allstudent} rules={{ required: 'Please select an student'}}  value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.setState({ student: evt.value })}  required/>
                          </FormGroup>
                        </div>      

                                 {this.state.viewdiv && 
                                     <div className="col-sm-12 col-md-6 col-xl-6">
                                            <FormGroup>
                                               
                                                <DatePicker className="form-control" id="checkoutdate"  name="checkoutdate" autoComplete="off" required
                                                        selected={this.state.checkoutdate}
                                                        onChange={this.selectdate}
                                                        dateFormat='YYYY-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                    /> 
                                            </FormGroup>                                          
                                      </div>
                                }
                    </RctCollapsibleCard>
            </div>
           
        )
}
}

 const mapStateToProps = ({ mostlyused, ssteam }) => {
    const { studentlists, loading } = mostlyused;
    const { ssteamlists } = ssteam;
    return { studentlists, ssteamlists, loading };
   
}

 export default connect(mapStateToProps, {
    allStudents,
    addTravelForm,
    allSSTeam
    
})(AddItems);